import { render, staticRenderFns } from "./shareJobContent.vue?vue&type=template&id=4c2fdc6d&scoped=true"
import script from "./shareJobContent.vue?vue&type=script&lang=js"
export * from "./shareJobContent.vue?vue&type=script&lang=js"
import style0 from "./shareJobContent.vue?vue&type=style&index=0&id=4c2fdc6d&prod&lang=scss&scoped=true"
import style1 from "./shareJobContent.vue?vue&type=style&index=1&id=4c2fdc6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2fdc6d",
  null
  
)

export default component.exports